"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _RegionStorePane = _interopRequireDefault(require("../RegionStorePane"));
var _goods_activity_combo = require("@/api/goods_activity/goods_activity_combo");
var _best_buys = require("@/api/goods_activity/best_buys");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BestBuysConfigPane',
  components: {
    RegionStorePane: _RegionStorePane.default
  },
  props: {
    bestBuysFnId: {
      type: String,
      default: ''
    } // 超值ID
  },
  data: function data() {
    return {
      menuTypeList: [],
      // 点餐类型列表
      form: {
        activityName: '',
        // 活动名称
        activityPrice: null,
        // 活动价格
        menuTypes: [],
        // 点餐类型
        vipMember: true,
        memberLevels: [],
        executeDateList: [],
        // 执行日期
        executeTimeList: ['09:00', '23:00'],
        // 执行时间
        markForEnable: true,
        // 是否启用
        storeScope: 0,
        // 店铺范围
        checkedSuggestGoodsList: [],
        // 推荐商品ID
        relatedStoreIdList: [] // 指定门店ID
      },
      memberLevelList: [],
      // 会员等级列表
      regionStoreList: [],
      // 指定区域门店
      goodsTableKey: 0,
      // 商品表格key
      suggestGoods: {},
      // 搜索推荐商品
      suggestGoodsList: [],
      // 推荐商品列表
      searchSuggestGoodsLoading: false
    };
  },
  watch: {
    'form.vipMember': function formVipMember(newVal) {
      if (newVal === true) {
        // 选中会员时，默认选中所有等级
        this.form.memberLevels = this.memberLevelList.map(function (item) {
          return item.gradeId;
        });
      } else {
        // 取消会员时，清空等级选择
        this.form.memberLevels = [];
      }
    }
  },
  created: function created() {
    this.getMenuType();
    this.queryRegionStoreList();
    this.getMemberLevelList();
    if (this.bestBuysFnId) {
      this.getBestBuysDetail();
    }
  },
  methods: {
    getBestBuysDetail: function getBestBuysDetail() {
      var _this = this;
      (0, _best_buys.getBestBuysDetail)(this.bestBuysFnId).then(function (response) {
        var data = response.data;
        if (data && data.xyGaBestBuys) {
          _this.form.activityName = data.xyGaBestBuys.activityName;
          _this.form.activityPrice = data.xyGaBestBuys.activityPrice;
          _this.form.menuTypes = data.menuTypes || [];
          _this.form.executeDateList = data.executeDateList || [];
          _this.form.executeTimeList = data.executeTimeList || ['09:00', '23:00'];
          _this.form.vipMember = data.xyGaBestBuys.vipMember;
          _this.form.memberLevels = data.memberLevels || [];
          _this.form.markForEnable = data.xyGaBestBuys.markForEnable;
          _this.form.storeScope = data.xyGaBestBuys.storeScope;
          _this.form.checkedSuggestGoodsList = (data.checkedSuggestGoodsList || []).map(function (item, index) {
            return _objectSpread(_objectSpread({}, item), {}, {
              sorts: item.sorts !== null && item.sorts !== undefined ? item.sorts : index + 1
            });
          });
          _this.form.relatedStoreIdList = data.relatedStoreIdList || [];
        }
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;
      (this.form.checkedSuggestGoodsList || []).forEach(function (item, index) {
        if (item.sorts === undefined || item.sorts === null) {
          item.sorts = index + 1;
        }
      });
      if (this.bestBuysFnId) {
        // 编辑
        var editData = _objectSpread(_objectSpread({}, this.form), {}, {
          fnId: this.bestBuysFnId
        });
        (0, _best_buys.bestBuysEdit)(editData).then(function (res) {
          _this2.$message.success(res.message);
          _this2.$emit('success');
        });
      } else {
        // 新建
        (0, _best_buys.bestBuysSave)(this.form).then(function (res) {
          _this2.$message.success(res.message);
          _this2.$emit('success');
        });
      }
    },
    handleRegionStoreChange: function handleRegionStoreChange(checkedStoreIds, regionStore) {
      var _this$form$relatedSto;
      // 获取当前区域的所有门店ID
      var currentRegionStoreIds = regionStore.storeList.map(function (s) {
        return s.storeId;
      });
      // 先从 relatedStoreIdList 中移除当前区域的所有门店
      this.form.relatedStoreIdList = this.form.relatedStoreIdList.filter(function (id) {
        return !currentRegionStoreIds.includes(id);
      });
      // 再添加当前区域选中的门店
      (_this$form$relatedSto = this.form.relatedStoreIdList).push.apply(_this$form$relatedSto, (0, _toConsumableArray2.default)(checkedStoreIds));
    },
    removeReferraltGoods: function removeReferraltGoods(item) {
      var index = -1;
      for (var i = 0; i < this.form.checkedReferralGoodsList.length; i++) {
        var referralGoods = this.form.checkedReferralGoodsList[i];
        if (item.goodsFnId === referralGoods.goodsFnId) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        this.form.checkedReferralGoodsList.splice(index, 1);
      }
    },
    removeSuggestGoods: function removeSuggestGoods(item) {
      var index = -1;
      for (var i = 0; i < this.form.checkedSuggestGoodsList.length; i++) {
        var suggestGoods = this.form.checkedSuggestGoodsList[i];
        if (item.goodsFnId === suggestGoods.goodsFnId && item.unitFnId === suggestGoods.unitFnId) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        this.form.checkedSuggestGoodsList.splice(index, 1);
      }
    },
    // 整体价格变化时的处理
    handleActivityPriceChange: function handleActivityPriceChange(value) {
      if (value !== null && value !== undefined) {
        // 可选：自动同步价格到所有商品
        // 如果需要自动同步，取消下面的注释
        // this.applyPriceToAllGoods()
      }
    },
    // 应用整体价格到所有商品
    applyPriceToAllGoods: function applyPriceToAllGoods() {
      var _this3 = this;
      if (this.form.activityPrice !== null && this.form.activityPrice !== undefined) {
        this.$confirm('确定要将整体价格应用到所有商品吗？这会覆盖所有商品的单独设置的价格。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this3.form.checkedSuggestGoodsList.forEach(function (item) {
            item.goodsPrice = _this3.form.activityPrice;
          });
          _this3.goodsTableKey++;
          _this3.$message.success('已应用到所有商品');
        }).catch(function () {
          // 取消操作
        });
      } else {
        this.$message.warning('请先设置整体价格');
      }
    },
    addSuggestGoods: function addSuggestGoods() {
      var exist = false;
      if (this.suggestGoods && this.suggestGoods.goodsFnId && this.suggestGoods.unitFnId) {
        for (var i = 0; i < this.form.checkedSuggestGoodsList.length; i++) {
          var item = this.form.checkedSuggestGoodsList[i];
          if (item.goodsFnId === this.suggestGoods.goodsFnId && item.unitFnId === this.suggestGoods.unitFnId) {
            exist = true;
            break;
          }
        }
        if (!exist) {
          // 如果设置了整体价格，新添加的商品默认使用整体价格
          if (this.form.activityPrice !== null && this.form.activityPrice !== undefined) {
            this.suggestGoods.goodsPrice = this.form.activityPrice;
          }
          this.suggestGoods.sorts = this.form.checkedSuggestGoodsList.length + 1;
          this.form.checkedSuggestGoodsList.push(this.suggestGoods);
        }
      }
      this.suggestGoods = {};
    },
    searchSuggestGoods: function searchSuggestGoods(query) {
      var _this4 = this;
      this.searchSuggestGoodsLoading = true;
      (0, _goods_activity_combo.queryGoodsAndSpecSearch)({
        keywords: query
      }).then(function (res) {
        var data = res.data;
        if (data) {
          _this4.suggestGoodsList = data.goodsList || [];
          _this4.searchSuggestGoodsLoading = false;
        }
      }, function () {
        _this4.searchSuggestGoodsLoading = false;
      });
    },
    queryRegionStoreList: function queryRegionStoreList() {
      var _this5 = this;
      (0, _goods_activity_combo.queryRegionStoreList)().then(function (res) {
        var data = res.data;
        if (data) {
          _this5.regionStoreList = data.storeRegions || [];
        }
      });
    },
    getMemberLevelList: function getMemberLevelList() {
      var _this6 = this;
      (0, _goods_activity_combo.queryMemberLevelList)().then(function (res) {
        _this6.memberLevelList = res.data || [];
      });
    },
    getMenuType: function getMenuType() {
      var _this7 = this;
      (0, _goods_activity_combo.queryMenuType)().then(function (res) {
        var data = res.data;
        if (data) {
          _this7.menuTypeList = data.records || [];
        }
      });
    }
  }
};